//libs
import { useState, useEffect, useRef } from 'react';

//styling
import './Home.scss';

//assets
import { projectFirestore } from "../../firebase/config";
import { navClose, navOpen, projectDataLeft, projectDataRight } from '../../hooks/gsap/HomeController';
import HomeLink from '../../components/_default/HomeLink';
import SocialLink from '../../components/Home/SocialLink';
import NavArrow from '../../assets/images/img/navarrow.svg';
import Amazon from "../../assets/images/socials/amazon.svg";
import Github from "../../assets/images/socials/github.svg";
import Facebook from "../../assets/images/socials/facebook.svg";
import Call from "../../assets/images/socials/call.svg";
import Email from "../../assets/images/socials/email.svg";
import Linkedin from "../../assets/images/socials/linkedin.svg";
import Spotify from "../../assets/images/socials/spotify.svg";
import Instagram from "../../assets/images/socials/instagram.svg";
import Codepen from "../../assets/images/socials/codepen.svg";

function Home() {
  //useState
  const [firstTime, setFirstTime] = useState(true)
  const [projects, setProjects] = useState(false)
  const [projectId, setProjectId] = useState("1")
  const [dataProjects, setDataProjects] = useState(null)
  const [dataProjectDetails, setDataProjectDetails] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState(false)

  //useRef
  let nav = useRef(null);
  let projectLeft = useRef(null);
  let projectRight = useRef(null);

  //button rotate prop
  const rotate = projects ? "rotate(180deg)" : "rotate(0deg)"

  //gsap nav animaties
  useEffect(() => {
    //zodat het bij de render niet animeert
    if (!firstTime) {
      //checkt welke gsaphooks functie moet runnen
      if (projects) {
        navOpen(nav, setProjects)
      } else {
        navClose(nav, setProjects)
      }
    }
    else {
      setFirstTime(false)
    }
  }, [projects]);

  //gsap project data animaties
  useEffect(() => {
    if (projects) {
      projectDataLeft(projectLeft)
      projectDataRight(projectRight)
    }
  }, [projectId]);

  //get all projects
  useEffect(() => {
    projectFirestore.collection('projects').get()
      .then((snapshot) => {
        if (snapshot.empty) {
          console.log("Geen projects!!!!!!")
        } else {
          let results = []
          snapshot.docs.forEach(doc => {
            results.push({ id: doc.id, ...doc.data() })
          })
          setDataProjects(results)
        }
      }).catch(err => {
        console.log(err.message)
      })
  }, [])

  //get project on id
  useEffect(() => {
    setIsPending(true)

    projectFirestore.collection('projects').doc(projectId).get()
      .then((doc) => {
        if (doc.exists) {
          setIsPending(false)
          setDataProjectDetails(doc.data())
        } else {
          setIsPending(false)
          setError(true)
        }
      })
  }, [projectId]);

  return (
    <main className='home_container'>
      <HomeLink />

      {!projects ? (
        <section className='home_screen'>
          <h1 className='visually-hidden'>homescreen</h1>
          <div className='home_screen_box'>
            <p className='home_screen_title'>Hi, my name is <span>Conor Vanoystaeyen.</span> I'm passionate about </p>
            <div className='home_screen_word'>
              <span>React</span>
              <span>React Native</span>
              <span>Websites</span>
              <span>Webapps</span>
              <span>Mobile apps</span>
            </div>
          </div>
          <div className='home_screen_links'>
            <SocialLink img={Amazon} height={51} width={51} link="https://www.amazon.nl/hz/wishlist/ls/37G6GGT1A8Q2E/ref=nav_wishlist_lists_1?_encoding=UTF8&type=wishlist" name="Amazon" />
            <SocialLink img={Github} height={79} width={79} link="https://github.com/conor-v" name="Github" />
            <SocialLink img={Facebook} height={59} width={59} link="https://www.facebook.com/conor.vanoystaeyen" name="Facebook" />
            <SocialLink img={Call} height={41} width={41} link="tel:+32494782330" name="Call" />
            <SocialLink img={Email} height={78} width={78} link="mailto:conor.vanoystaeyen@hotmail.com" name="Email" />
            <SocialLink img={Linkedin} height={47} width={47} link="https://www.linkedin.com/in/conor-vanoystaeyen-20478a137/" name="Linkedin" />
            <SocialLink img={Spotify} height={64} width={64} link="https://open.spotify.com/user/9pqtalboc2v0hiwgq8qtrlkro" name="Spotify" />
            <SocialLink img={Instagram} height={38} width={38} link="https://www.instagram.com/conorvanoystaeyen/" name="Instagram" />
            <SocialLink img={Codepen} height={72} width={72} link="https://codepen.io/ConorV" name="Codepen" />
          </div>
        </section>
      ) : (
        <section className='project_content'>
          <h1 className='visually-hidden'>project details</h1>
          <div ref={projectLeft} className='project_content_left'>
            <h2 className='contentL_title'>{dataProjectDetails.title}</h2>
            <p className='contentL_tech'>{dataProjectDetails.tech}</p>
            <ul className='contentL_list_tags'>
              {dataProjectDetails.tags.map((tag, index) => (
                <li key={index} className='contentL_list_tag'>{tag}</li>
              ))}
            </ul>
            <p className='contentL_text'>{dataProjectDetails.text}</p>
            <ul className='contentL_list_buttons'>
              {dataProjectDetails.code &&
                <li className='contentL_list_button'><a href={dataProjectDetails.code} target="_blank" rel="noreferrer">Code</a></li>
              }
              {dataProjectDetails.view &&
                <li className='contentL_list_button'><a href={dataProjectDetails.view} target="_blank" rel="noreferrer">View</a></li>
              }
            </ul>
          </div>
          <div ref={projectRight} className='project_content_right'>
            <img src={dataProjectDetails.sideImg} alt={dataProjectDetails.title} />
          </div>
        </section>
      )}

      <section className='project_navbar' ref={nav}>
        <h1 className='visually-hidden'>view projects</h1>
        <button className={`project_navbar_button ${projects ? "" : "project_navbar_button-action"}`} style={{ bottom: projects ? "210px" : "5px" }} onClick={() => setProjects(!projects)}>
          <p>View Projects</p>
          <img style={{ transform: rotate, transition: "all .2s linear" }} src={NavArrow} alt="arrow" />
        </button>
        {projects && dataProjects &&
          <div className='project_list'>
            <ul className='project_list_items'>
              {dataProjects.map((data) => (
                <li key={data.id} onClick={() => setProjectId(data.id)}>
                  <button className={`project_list_item  ${projectId === data.id ? "project_list_item_active" : ""}`}>
                    <div className='project_list_item_bg' style={{ backgroundColor: `#${data.bgColor}` }}></div>
                    <img className='project_list_item_img' src={data.icon} alt={data.title} height={73} />
                    <h2 className='project_list_item_title'>{data.title}</h2>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        }
      </section>
    </main>
  );
}

export default Home;
